import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Seo from "@/components/Seo";

const NotFound = () => {
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-background text-foreground px-6">
      <Seo title={t("seo.notFound.title")} description={t("seo.notFound.desc")} path="/404" />
      <div id="main" tabIndex={-1} className="max-w-[1400px] mx-auto flex flex-col min-h-screen py-10 outline-none">
        {/* Top annotation row */}
        <div className="flex items-center justify-between ed-eyebrow text-muted-foreground animate-fade-in">
          <span className="inline-flex items-center gap-2">
            <span className="inline-block w-1.5 h-1.5 rounded-full bg-brand ed-blink" />
            {t("notFound.label")}
          </span>
          <span>{t("notFound.side")}</span>
        </div>

        {/* Giant statement */}
        <div className="flex-1 flex flex-col justify-center py-10">
          <h1 className="ed-mega animate-fade-in">
            404<span className="text-brand">.</span>
          </h1>

          <p className="ed-serif text-2xl md:text-4xl max-w-2xl mt-8 text-foreground/85 animate-fade-in-delay-1">
            {t("notFound.subPrefix")}{" "}
            <span className="not-italic font-display font-semibold text-brand break-all">
              {location.pathname}
            </span>
            {t("notFound.subSuffix")}
          </p>
        </div>

        {/* Bottom row - actions + contact annotation */}
        <div className="ed-rule pt-8 flex flex-col gap-8 md:flex-row md:items-end md:justify-between animate-fade-in-delay-2">
          <div className="flex flex-wrap gap-3">
            <a href="/" className="ed-btn ed-btn-solid">
              {t("notFound.back")}
            </a>
          </div>

          <p className="ed-eyebrow text-muted-foreground max-w-xs md:text-right">
            {t("notFound.contactPrefix")}{" "}
            <a href="/contact" className="ed-link normal-case tracking-normal text-foreground">
              {t("notFound.contactLink")}
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
